import { BookOpen, Building2, Images } from "lucide-react";

/* ============================================================
   DAFTAR BAGIAN "TENTANG KAMI" - SATU-SATUNYA SUMBER

   Dibaca oleh app/tentang-kami/TentangContent.jsx.

   Isinya SENGAJA SAMA PERSIS dengan dropdown "Tentang Kami" di
   Header.jsx (baris 249-253): tiga item, urutan yang sama, ikon yang
   sama. Halaman ini adalah versi halaman penuh dari menu itu - kalau
   isinya berbeda, pengunjung mendapat dua jawaban untuk pertanyaan
   yang sama.

   ⚠️ HEADER BELUM MEMBACA BERKAS INI. Daftarnya masih ditulis ulang di
   Header.jsx, jadi untuk sekarang menambah item berarti mengubah DUA
   tempat. Kalau nanti kamu mau menyatukannya - seperti yang sudah
   dilakukan untuk layanan lewat app/data/layanan.js - ganti isi
   MENUS[1].items di Header.jsx jadi:

       items: BAGIAN_TENTANG.map((b) => ({
         titleKey: `header.tentang.${b.key}`,
         descKey:  `header.tentang.${b.key}Desc`,
         href:     b.href,
         icon:     b.Icon,
       })),

   ============================================================
   FIELD

   key   - kunci terjemahan. Judul dibaca dari header.tentang.{key},
           deskripsi dari header.tentang.{key}Desc. Keduanya SUDAH ADA
           di dictionary.js, jadi berkas ini tidak menuntut satu pun
           kunci baru.

   href   - alamat lengkap, BUKAN slug.

            Berbeda dengan layanan yang semuanya berada di bawah
            /layanan/, ketiga bagian ini tidak berbagi satu induk:
            Edukasi Kesehatan ada di /edukasi-kesehatan, di luar
            /tentang-kami. Merakit alamatnya dari slug akan memaksa
            pengecualian untuk satu item - lebih jujur menulis
            alamatnya utuh.

   Icon   - komponen lucide-react, huruf besar. React memperlakukan tag
            berhuruf kecil sebagai elemen HTML biasa, jadi `icon` akan
            menghasilkan error "Element type is invalid".

   image  - sampul kartu. null berarti jatuh ke ikon yang diperbesar.

   muat   - cara gambar mengisi bingkai 4:3 kartu. Boleh dikosongkan.

            (kosong)    -> object-cover. Gambar dibesarkan sampai
                           MEMENUHI bingkai, sisi yang berlebih
                           dipotong. Benar untuk foto: bingkai terisi
                           penuh, dan sedikit terpotong tidak masalah.

            "contain"   -> object-contain. Gambar dikecilkan sampai
                           MUAT SELURUHNYA, sisanya jadi ruang kosong.
                           Wajib untuk logo dan gambar berlatar
                           transparan.

            KENAPA INI PERLU. logo.png berukuran 360x148, rasionya 2,43
            - jauh lebih melebar daripada bingkai 4:3 (1,33). Dengan
            object-cover, browser memotong hampir separuh lebarnya dan
            yang tersisa hanya bagian tengah logo.

            Aturan praktisnya: logo, ikon, dan apa pun berlatar
            transparan pakai "contain"; foto pakai bawaan.

   ============================================================
   BUSINESS UNIT SENGAJA TIDAK ADA DI SINI

   Ia pernah jadi item keempat lalu dihapus atas permintaan - catatannya
   masih tersimpan di Header.jsx baris 264-275. Halaman
   /tentang-kami/business-unit juga tidak pernah dibuat.

   Kalau suatu saat dikembalikan, tambahkan barisnya di sini DAN di
   Header.jsx, lalu buat halamannya lebih dulu. Kunci terjemahannya
   (header.tentang.businessUnit dan businessUnitDesc) masih tersimpan
   di dictionary.js, jadi tidak perlu ditulis ulang.
   ============================================================ */

export const BAGIAN_TENTANG = [
  {
    key: "about",
    href: "/tentang-kami/about",
    Icon: Building2,

    /* LOGO, BUKAN FOTO - karena itu perlu "contain".

       logo.png berlatar transparan, jadi ruang kosong di kiri-kanannya
       akan terisi gradasi merah muda milik kartu. Hasilnya terbaca
       seperti kartu bermerek, bukan seperti foto yang gagal dimuat.

       Kalau nanti kamu ingin memakai foto gedung, ganti image ke
       "/images/gallery/7.jpg" dan HAPUS baris `muat` - foto harus
       memenuhi bingkai, bukan dimuatkan. */
    image: "/images/logo.png",
    muat: "contain",
  },
  {
    key: "gallery",
    href: "/tentang-kami/gallery",
    Icon: Images,
    image: "/images/Gedung.png",
  },
  {
    key: "edukasi",
    href: "/edukasi-kesehatan",
    Icon: BookOpen,

    /* SAMPUL RAKITAN, BUKAN FOTO TUNGGAL.

       Ketiga puluh dua berkas di tiga folder edukasi - edukasi-kesehatan,
       edukasi-kesehatan-flyyer, dan edukasi-kesehatan-poster - semuanya
       bertopik spesifik - hipertensi, PPOK, diabetes, batu
       empedu, kehamilan ektopik, dan seterusnya. Memakai salah satunya
       sebagai sampul akan menjadikan satu penyakit wajah dari seluruh
       bagian Edukasi Kesehatan.

       edukasi-cover.jpg disusun dari EMPAT poster milik RS sendiri -
       anak, lansia, diabetes, hipertensi - dijejer seperti setumpuk
       materi cetak di atas gradasi merah muda yang sama dengan latar
       kartunya. Yang terwakili jadi "kumpulan materinya", bukan satu
       topik.

       BUKAN SOLUSI PERMANEN. Begitu poster-poster itu diperbarui,
       sampul ini ikut basi karena isinya salinan versi lama. Yang
       lebih tahan lama adalah satu foto asli: perawat sedang memberi
       penyuluhan, atau rak materi edukasi di lobi. Ganti berkasnya
       kalau foto itu sudah ada - nama dan path-nya tidak perlu
       berubah.

       ⚠️ "contain", SAMA SEPERTI LOGO - dan alasannya sama.

       Latar berkasnya kini putih, bukan lagi gradasi merah muda.
       Dengan object-cover, poster-posternya dibesarkan sampai
       memenuhi bingkai 4:3 dan tepi kiri-kanannya terpotong - poster
       paling luar tersentuh tepi kartu. Itu benar untuk foto, tapi
       gambar ini bukan foto: ia susunan bidang datar yang batas
       luarnya memang bagian dari gambarnya.

       "contain" membuatnya muat seluruhnya, dan padding di kartunya
       memberi ruang di kiri-kanan.

       ⚠️ AKIBATNYA POSTERNYA TAMPIL LEBIH KECIL daripada saat
       object-cover. Itu memang harga dari tidak memotongnya. Kalau
       terasa terlalu kecil, yang diperbaiki BUKAN kembali ke cover,
       melainkan mengekspor ulang gambarnya dengan rasio lebih dekat
       ke 4:3 supaya ruang kosongnya berkurang. */
    image: "/images/edukasicover.png",
    muat: "contain",
  },
];
